import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { Component } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import {
    MonUIRouterTransitionService,
} from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { ReadabilitySummaryComponent } from '@client/app/pages/qa/readability/summary/summary.component';
import { ReadabilityCheckerComponent } from '@client/app/pages/qa/readability/checker/checker.component';

@Component({
    selector: 'base-qa-readability',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BaseQAReadabilityComponent {}

export const QA_READABILITY_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.domain.qa.readability',
        url: '/readability',
        abstract: true,
        views: {
            'content@base.customer.domain.qa': {
                component: BaseQAReadabilityComponent,
            },
        },
        redirectTo: 'base.customer.domain.qa.readability.dashboard',
        // No shellPath here: abstract parents are not navigation targets.
        // The prefix is owned by the dashboard leaf below (as a shellAlias).
        data: {
            sidebar: 'quality',
        },
        resolve: [{
            token: 'domainHasReadabilityFeature',
            deps: [
                SessionService,
                StateService,
                ActiveFeatureService,
                MonUIRouterTransitionService,
                Transition,
            ],
            resolveFn: async (
                ng2SessionService: SessionService,
                $state: StateService,
                ng2ActiveFeatureService: ActiveFeatureService,
                ng2MonUIRouterTransitionService: MonUIRouterTransitionService,
                transition: Transition,
            ) => {
                if (
                    ng2SessionService.domain?.features.readability_test === null ||
                    !ng2ActiveFeatureService.isFeatureActivePure('admin_readability')
                ) {
                    setTimeout(function () {
                        ng2MonUIRouterTransitionService.onTransitionFinished(
                            () => {
                                $state.go('base.customer.domain.qa.summary', transition.params());
                            },
                        );
                    });
                    return Promise.resolve(false);
                } else {
                    return Promise.resolve(true);
                }
            },
        }],
    },
    {
        name: 'base.customer.domain.qa.readability.dashboard',
        url: '/dashboard',
        views: {
            'content@base.customer.domain.qa.readability': {
                component: ReadabilitySummaryComponent,
            },
        },
        data: {
            /** Shell-facing path for CC breadcrumb/menu sync (see event-bus-bridge.init.ts) */
            shellPath: '/domains/:domainId/quality/readability/dashboard',
            // Incoming alias: breadcrumb clicks on 'Readability' use the group prefix.
            shellAliases: ['/domains/:domainId/quality/readability'],
        },
    },
    {
        name: 'base.customer.domain.qa.readability.checker',
        url: '/checker',
        views: {
            'content@base.customer.domain.qa.readability': {
                component: ReadabilityCheckerComponent,
            },
        },
        data: {
            shellPath: '/domains/:domainId/quality/readability/checker',
        },
    },
];
